export default __webpack_public_path__ + "static/media/LostRfpDetailsLightActive.b03eaeca.svg";